import { redirect } from "@/utils/redirect";
import { ref } from "vue";
import { LeaveConfirmationData } from "@/types";

let leaveUrl: string;

export const confirmationData = ref<LeaveConfirmationData | undefined>(
  undefined
);

export const isConfirmationOpen = ref(false);
export const isConfirmationDisabled = ref(false);

export const leaveWithConfirmation = (url: string, $event?: Event): void => {
  if (!confirmationData.value || isConfirmationDisabled.value) {
    return;
  }

  $event?.preventDefault();
  isConfirmationOpen.value = true;
  leaveUrl = url;
};

export const confirm = (): void => {
  redirect(leaveUrl);
};

export const cancel = (): void => {
  isConfirmationOpen.value = false;
};

export const disableConfirmation = (value = true): void => {
  isConfirmationDisabled.value = value;
};
